import styled from "styled-components";

export const AccordionContainer = styled.div`
  border: 1px solid var(--color-neutral-200);
  border-radius: 8px;
  overflow: hidden;
`;

export const AccordionTitle = styled.button`
  all: unset;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.15px;
  color: var(--color-accent);
  padding: 0.5rem 1rem;
  cursor: pointer;
`;

export const ArrowWrapper = styled.span<{ $open: boolean }>`
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
  transform: ${({ $open }) => ($open ? "rotate(0deg)" : "rotate(180deg)")};
`;

export const SubAccordionTitle = styled.button`
  all: unset;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.15px;
  color: var(--color-accent);
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-top: 1px solid var(--color-neutral-200);

  background-color: var(--color-neutral-400);
`;

export const GridContainer = styled.div`
  margin-top: 8px;
`;

export const GridRow = styled.div<{ $index: number }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 34px;
  align-items: center;
  padding: 0 16px;
  background-color: ${({ $index }) =>
    $index % 2 === 0 ? "var(--color-bg)" : "var(--color-neutral-400)"};

  & > * {
    min-width: 0;
  }
`;

export const GridLabel = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text-muted);
  text-align: left;
`;

export const GridValue = styled.span<{ $overflows?: boolean }>`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text);
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: ${({ $overflows }) => ($overflows ? "pointer" : "default")};
`;

export const AccordionButtonContainer = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text-muted);
  text-align: left;

  button {
    background-color: (var(--color-primary));
    border: none;

    text-align: left;

    padding: 0;

    text-decoration: underline;
    color: var(--color-text-link);

    cursor: pointer;
  }
`;
